(function () {
  'use strict';

  const tiers = [
    { threshold: 3900, variantId: 43616650362947, title: 'Free Random Beyblade', label: 'Spend $39+' },
    { threshold: 6500, variantId: 43616650395715, title: 'Free Launcher', label: 'Spend $65+' },
    { threshold: 12500, variantId: 43616650428483, title: 'Free 4-Pack & Launcher', label: 'Spend $125+' },
    { threshold: 18900, variantId: 43616650461251, title: 'Free Mini Stadium', label: 'Spend $189+' }
  ];
  const giftVariantIds = new Set(tiers.map((tier) => tier.variantId));
  const sectionIds = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  let syncing = false;
  let debounceTimer = null;

  function isGift(item) {
    return giftVariantIds.has(Number(item.variant_id));
  }

  function isBeybladeItem(item) {
    if (isGift(item)) return false;
    const haystack = [item.product_type, item.product_title, item.title, item.vendor, item.handle, item.url].filter(Boolean).join(' ').toLowerCase();
    return /bey\s*blade|takara tomy|hasbro beyblades|burst series|metal series|\bx series\b|beyblade x/.test(haystack);
  }

  function eligibleSubtotal(cart) {
    return cart.items.reduce((total, item) => isBeybladeItem(item) ? total + item.line_price : total, 0);
  }

  function renderProgress(cart) {
    const panel = document.querySelector('[data-tts-free-gifts]');
    if (!panel) return;
    const subtotal = eligibleSubtotal(cart);
    const unlocked = tiers.filter((tier) => subtotal >= tier.threshold);
    const nextTier = tiers.find((tier) => subtotal < tier.threshold);
    const pct = Math.max(0, Math.min(100, subtotal / tiers[tiers.length - 1].threshold * 100));
    const message = panel.querySelector('[data-tts-free-gift-message]');
    const bar = panel.querySelector('[data-tts-free-gift-fill]');
    const markers = panel.querySelectorAll('[data-tts-free-gift-marker]');

    if (message) {
      if (nextTier) {
        const remaining = ((nextTier.threshold - subtotal) / 100).toFixed(2);
        message.textContent = '$' + remaining + ' in Beyblade items away from ' + nextTier.title + '.';
      } else {
        message.textContent = 'All Tyson\'s Toy Store rewards unlocked.';
      }
    }
    if (bar) bar.style.width = pct + '%';
    markers.forEach((marker) => {
      const variantId = Number(marker.getAttribute('data-variant-id'));
      marker.classList.toggle('is-unlocked', unlocked.some((tier) => tier.variantId === variantId));
    });
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    return response.json();
  }

  async function addGift(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _tts_free_gift: 'true' } })
    });
  }

  async function removeGift(item) {
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  async function refreshCartSections(cart) {
    const response = await fetch(window.location.pathname + '?sections=' + sectionIds, { credentials: 'same-origin' });
    const sections = await response.json();
    if (window.theme) window.theme.cartItemCount = cart.item_count;
    window.dispatchEvent(new CustomEvent('shapes:cart:update', { detail: { response: { sections: sections } } }));
  }

  async function syncFreeGifts() {
    if (syncing) return;
    syncing = true;
    try {
      let cart = await fetchCart();
      const subtotal = eligibleSubtotal(cart);
      let changed = false;

      for (const tier of tiers) {
        const item = cart.items.find((cartItem) => Number(cartItem.variant_id) === tier.variantId);
        const qualifies = subtotal >= tier.threshold;
        if (qualifies && !item) {
          await addGift(tier.variantId);
          changed = true;
        } else if (!qualifies && item) {
          await removeGift(item);
          changed = true;
        } else if (item && item.quantity !== 1) {
          await removeGift(item);
          await addGift(tier.variantId);
          changed = true;
        }
      }

      if (changed) cart = await fetchCart();
      renderProgress(cart);
      if (changed) await refreshCartSections(cart);
    } catch (error) {
      console.error('Tyson free gift sync failed', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGifts, 250);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('shapes:cart:afteradditem', scheduleSync);
  window.addEventListener('shapes:cart:cartqtychange', scheduleSync);
  window.addEventListener('shapes:cart:update', scheduleSync);
  document.addEventListener('theme:product:add', scheduleSync);
  document.addEventListener('theme:line-item:change', scheduleSync);
})();